module.exports = __webpack_public_path__ + "prod/1.42.2/img/debang-icon.abf55954.png";